import { Box, TextField } from '@mui/material'

interface ThemeColorFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
}

export function ThemeColorField({ label, value, onChange }: ThemeColorFieldProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <input
        type="color"
        value={value || '#000000'}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: 40, height: 40, border: 'none', cursor: 'pointer', padding: 0 }}
      />
      <TextField
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        size="small"
        sx={{ flex: 1 }}
        placeholder="#000000"
      />
    </Box>
  )
}
